import React, { Dispatch, SetStateAction, useState } from "react";
import {
  Box,
  Button,
  SxProps,
  Theme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

type Props = {
  open: boolean;
  onBack: Function
  onClose: Function
}

/**
 * 本部用注文作成モーダルで戻るボタンを押下した際に表示される確認モーダル
 * @param root0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function BackAlert({
  open,
  onBack,
  onClose,
}: Props) {
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>確認</DialogTitle>
      <DialogContent>
        戻ると入力内容は失われますが、よろしいですか？
      </DialogContent>
      <DialogActions>
        <Button variant="custom-outlined" onClick={() => onClose()}>
          キャンセル
        </Button>
        <Button variant="contained" onClick={() => onBack()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}